import React from 'react';
import { t } from '@sm/intl';
import { DetailsFeatureRowPackages } from '~app/pages/Pricing/transformers/details/types';
import PackageDefs from '~app/pages/Pricing/lib/packages/packageDefs';
import { PackageDefs as Grow2792PackageDefs } from '../../constants';

import useCategoryStyles from './useStyles';
import COPY from './copy';

const expPackageDefs = { ...PackageDefs, ...Grow2792PackageDefs };

export default function FeatureCell(pkg: Readonly<DetailsFeatureRowPackages>): JSX.Element {
  const { Cell, Bullet, BulletInverse, Highlighted } = useCategoryStyles({ packageName: pkg.packageName });
  let a11yValue = COPY.UNAVAILABLE.defaultMessage;

  if (typeof pkg.value === 'string') {
    a11yValue = pkg.value;
  } else if (pkg.value) {
    a11yValue = COPY.AVAILABLE.defaultMessage;
  }

  return (
    <div
      role="cell"
      aria-label={`${pkg.packageName} ${a11yValue}`}
      aria-roledescription={t(COPY.CELL_ARIA_ROLE_DESC_2792)}
      className={`${Cell} ${expPackageDefs[pkg.packageName]?.highlighted ? Highlighted : ''}`}
      tabIndex={-1}
      data-testid="FeatureCell"
    >
      {typeof pkg.value === 'boolean'
        ? pkg.value && <span className={expPackageDefs[pkg.packageName]?.highlighted ? BulletInverse : Bullet} />
        : pkg.value}
    </div>
  );
}
